<template>
  <div class="container">
    <div class="limited">
      <svg
        class="earth"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="200"
        height="200"
        viewBox="0 0 172 172"
        style=" fill:#000000;"
      >
        <g
          fill="none"
          fill-rule="nonzero"
          stroke="none"
          stroke-width="1"
          stroke-linecap="butt"
          stroke-linejoin="miter"
          stroke-miterlimit="10"
          stroke-dasharray
          stroke-dashoffset="0"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode: normal"
        >
          <path d="M0,172v-172h172v172z" fill="none" />
          <g>
            <path
              d="M18.99164,55.47603c-17.24949,36.99333 -1.24394,80.96583 35.74939,98.21532c36.99333,17.24949 80.96583,1.24394 98.21532,-35.74939c17.24949,-36.99333 1.24394,-80.96583 -35.74939,-98.21532c-36.99333,-17.24949 -80.96583,-1.24394 -98.21532,35.74939z"
              fill="#bdd5e6"
            />
            <path
              d="M119.59375,2.6875c-20.425,0 -36.95312,16.52813 -37.625,37.49063c-0.5375,19.48438 18.14063,45.15 29.29375,58.5875c2.01563,2.41875 5.10625,3.89688 8.33125,3.89688c3.225,0 6.18125,-1.47812 8.33125,-3.89688c11.15313,-13.57188 29.96563,-39.10312 29.29375,-58.5875c-0.67187,-20.9625 -17.2,-37.49062 -37.625,-37.49062z"
              fill="#666666"
            />
            <path
              d="M119.59375,26.875c-7.42133,0 -13.4375,6.01617 -13.4375,13.4375c0,7.42133 6.01617,13.4375 13.4375,13.4375c7.42133,0 13.4375,-6.01617 13.4375,-13.4375c0,-7.42133 -6.01617,-13.4375 -13.4375,-13.4375z"
              fill="#bdd5e6"
            />
            <path
              d="M37.22187,142.03438v0c5.24063,4.56875 12.76563,5.24062 18.67813,1.88125c2.41875,-1.34375 4.97188,-2.95625 7.79375,-4.8375c1.88125,-1.34375 3.49375,-3.09063 4.70312,-5.10625c1.34375,-2.41875 2.95625,-4.97187 3.7625,-7.92812c5.24062,-20.15625 -12.22813,-20.9625 -12.76562,-25.39688c-0.5375,-4.97188 5.9125,-8.73437 9.80937,-12.63125c3.89688,-3.89687 5.10625,-9.94375 3.09063,-13.4375c-6.45,-11.55625 -21.76875,-5.50938 -23.24688,6.85313c-0.80625,7.39062 -5.24062,14.91562 -9.00312,18.8125c-3.7625,3.7625 -11.15312,1.74688 -13.16875,-3.7625c-2.28438,-6.18125 5.64375,-8.46563 4.43437,-16.39375c-0.26875,-2.15 -2.55312,-3.225 -5.375,-3.62812l-13.30312,0.5375c-0.26875,3.09063 -0.5375,6.31563 -0.5375,9.54063c0,16.52812 5.375,31.7125 14.64687,44.075c0,0 10.48125,10.07813 10.48125,11.42188z"
              fill="#034c90"
            />
            <path
              d="M86,164.60938c-11.2875,0 -22.44063,-2.41875 -32.92187,-7.39062c-18.8125,-8.73437 -33.19062,-24.45625 -40.3125,-43.94062c-7.12188,-19.48437 -6.18125,-40.58125 2.6875,-59.52812c10.48125,-22.44062 30.36875,-38.29687 54.69063,-43.26875c2.15,-0.40312 4.3,0.94062 4.8375,3.09063c0.40313,2.15 -0.94062,4.3 -3.09062,4.8375c-21.76875,4.56875 -39.64063,18.67813 -49.04687,38.83437c-7.92813,16.93125 -8.73438,35.87813 -2.28438,53.34688c6.31563,17.46875 19.21563,31.57812 36.14687,39.37188c16.93125,7.92812 35.87813,8.73438 53.34688,2.28437c17.46875,-6.31562 31.57812,-19.21562 39.37188,-36.14687c3.35938,-7.25625 5.50937,-14.91562 6.18125,-22.70938c0.26875,-2.15 2.28438,-3.89688 4.43438,-3.62812c2.15,0.26875 3.89687,2.15 3.62812,4.43437c-0.80625,8.73438 -3.225,17.33438 -6.9875,25.2625c-8.73437,18.8125 -24.45625,33.19063 -43.94063,40.3125c-8.73437,3.35938 -17.7375,4.8375 -26.74062,4.8375z"
              fill="#666666"
            />
          </g>
        </g>
      </svg>
      <h1 class="h2">Es tut uns leid!</h1>
      <h5 class="h5 messasge">
        Dieser Inhalt ist für Ihre Region nicht zugänglich.
      </h5>
    </div>
  </div>
</template>
<script>
export default {
  name: "geoLimit"
};
</script>
<style>
.limited {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.earth {
  margin-top: 50px;
  margin-bottom: 30px;
}
.messasge{
  margin-top:25px ;
}
</style>